module.exports = __webpack_public_path__ + "static/img/1007_big.785be1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1007_big.png
// module id = 5+hU
// module chunks = 1